import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";
import { values } from "lodash";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.QUICK_ADD_CUSTOMER).mergeMap(
    action =>
      new Promise((resolve, reject) => {
        const { location, registration } = action;

        firebase.database().ref(`issues/${registration.customers[0].customer}`).once('value')
          .then(issuesSnapshot => {

            const issues = issuesSnapshot.exists() ? values(issuesSnapshot.val()) : null;
            const ref = firebase
              .database()
              .ref(`queues/${location}`)
              .push();

            // Need to add any issues to the primary group member for the drawer to work.
            registration.customers[0].issues = issues;

            const quickAddRegistration = {
              member: registration.customers[0].member || false,
              active: registration.customers[0].active || false,
              flagged: (issues && issues.length > 0) ? true : false,
              issues,
              timestamp: new Date().getTime(),
              created: new Date().getTime(),
              updated: new Date().getTime(),
              group: registration.customers,
              ranges: registration.ranges,
              rental: registration.rental,
              registrationId: ref.key //use queue id as registration id so staff page will work
            };

            ref.set(quickAddRegistration)
              .then(() => resolve(Creators.updateQuickAddDrawerVisibility(false)))
              .catch(() => reject(Creators.updateQuickAddDrawerVisibility(false)));

          })
      })
  );



// WEBPACK FOOTER //
// ./src/staff/epics/quickAddCustomer.js